// Puntuación 0-100 de una contraseña. Copia de scorePassword() de
// server/services/passwordHealth.js: es la misma escala que usa la política
// `minPasswordScore` de las organizaciones. El panel la usa solo para avisar
// antes de enviar; quien decide es el servidor (422 `password_below_policy`).
// Si cambias una, cambia la otra: passwordScore.test.js fija los valores.

const COMMON_PASSWORDS = new Set([
  '123456', '123456789', 'qwerty', 'password', '12345', '12345678', '111111',
  '1234567', 'sunshine', 'qwerty123', 'iloveyou', '1q2w3e4r', '000000',
  'qwertyuiop', '123', 'monkey', 'dragon', '123321', 'password1', '1234',
  '654321', 'superman', 'qazwsx', 'michael', 'football', 'welcome', 'jesus',
  'ninja', 'mustang', 'password123', 'admin', 'login', 'princess', 'solo',
  'starwars', 'abc123', 'letmein', 'trustno1', '1qaz2wsx', 'baseball',
  'master', 'shadow', 'michael1', 'jennifer', 'hunter', 'harley', 'ranger',
  'buster', 'thomas', 'tigger', 'robert', 'soccer', 'batman', 'test',
  'passw0rd', 'access', 'flower', 'freedom', 'whatever', 'summer', 'internet',
  'samsung', 'iloveyou1', 'charlie', 'donald', 'daniel', 'matthew', 'andrew',
  '11111111', '00000000', 'asdfghjkl', 'zxcvbnm', 'aaaaaa', '121212',
  'qwe123', 'q1w2e3r4', 'changeme', 'default', 'guest', 'root', 'toor',
  'oliver', 'george', 'william', 'joshua', 'hannah', 'michelle', 'jordan',
  'amanda', 'ashley', 'nicole', 'chelsea', 'biteme', 'cookie', 'coffee',
  'chocolate', 'computer', 'corvette', 'yankees', 'dallas', 'phoenix',
  'redsox', 'liverpool', 'chelsea1', 'arsenal', 'manutd', 'porsche',
  '1234567890', '123123', '696969', '112233', '159753', '7777777',
  '8675309', 'a1b2c3', 'trustno1!', 'login123', 'welcome1', 'letmein1',
]);

const KEYBOARD_SEQUENCES = ['0123456789', 'abcdefghijklmnopqrstuvwxyz', 'qwertyuiop', 'asdfghjkl', 'zxcvbnm'];

function hasKeyboardSequence(pw) {
  const lower = pw.toLowerCase();
  for (const seq of KEYBOARD_SEQUENCES) {
    for (let i = 0; i <= seq.length - 4; i++) {
      const forward = seq.slice(i, i + 4);
      const backward = [...forward].reverse().join('');
      if (lower.includes(forward) || lower.includes(backward)) return true;
    }
  }
  return false;
}

function charsetSize(pw) {
  let size = 0;
  if (/[a-z]/.test(pw)) size += 26;
  if (/[A-Z]/.test(pw)) size += 26;
  if (/[0-9]/.test(pw)) size += 10;
  if (/[^a-zA-Z0-9]/.test(pw)) size += 32;
  return size || 1;
}

export function scorePassword(pw) {
  if (!pw || typeof pw !== 'string') return 0;
  if (COMMON_PASSWORDS.has(pw.toLowerCase())) return 5;

  const len = pw.length;
  let score = 0;

  if (len >= 8) score += 15;
  if (len >= 12) score += 20;
  if (len >= 16) score += 15;

  let classes = 0;
  if (/[a-z]/.test(pw)) classes++;
  if (/[A-Z]/.test(pw)) classes++;
  if (/[0-9]/.test(pw)) classes++;
  if (/[^a-zA-Z0-9]/.test(pw)) classes++;
  score += classes * 10;

  const entropy = len * Math.log2(charsetSize(pw));
  score += Math.min(30, Math.floor(entropy / 4));

  if (hasKeyboardSequence(pw)) score -= 20;
  if (/(.)\1{2,}/.test(pw)) score -= 15;
  if (/^\d+$/.test(pw)) score -= 15;

  return Math.max(0, Math.min(100, Math.round(score)));
}
